import React from 'react';
import { formatTimeString } from '../utils/dateUtils';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select';
import { cn } from '../lib/utils';

const TimePicker = ({ 
  value, 
  onChange, 
  placeholder = "00:00", 
  className = "",
  disabled = false 
}) => {
  // Генерируем список времени с шагом 15 минут
  const generateTimeOptions = () => {
    const options = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let minute = 0; minute < 60; minute += 15) {
        const timeObj = { hours: hour, minutes: minute };
        const timeStr = formatTimeString(hour, minute);
        options.push({ value: `${hour}:${minute}`, label: timeStr, timeObj });
      }
    }
    
    // Добавляем специальное время 23:59 как последнее значение
    const lastTimeObj = { hours: 23, minutes: 59 };
    const lastTimeStr = formatTimeString(23, 59);
    options.push({ value: "23:59", label: lastTimeStr, timeObj: lastTimeObj });
    
    return options;
  };

  const timeOptions = generateTimeOptions();
  const currentValue = value ? `${value.hours}:${value.minutes}` : "";

  const handleValueChange = (selectedValue) => {
    const option = timeOptions.find(opt => opt.value === selectedValue);
    if (option) {
      onChange(option.timeObj);
    }
  };

  return (
    <Select value={currentValue} onValueChange={handleValueChange} disabled={disabled}>
      <SelectTrigger className={cn("h-9 text-xs", className)}>
        <SelectValue placeholder={placeholder} />
      </SelectTrigger>
      <SelectContent>
        {timeOptions.map((option) => (
          <SelectItem key={option.value} value={option.value} className="text-xs">
            {option.label}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export default TimePicker;
